import { render, staticRenderFns } from "./mmNotify.vue?vue&type=template&id=fa9fa960&scoped=true"
import script from "./mmNotify.vue?vue&type=script&lang=js"
export * from "./mmNotify.vue?vue&type=script&lang=js"
import style0 from "./mmNotify.vue?vue&type=style&index=0&id=fa9fa960&prod&lang=css"
import style1 from "./mmNotify.vue?vue&type=style&index=1&id=fa9fa960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9fa960",
  null
  
)

export default component.exports